import LegalShell from "./LegalShell";

export default function SvaDetoxRefunds() {
  return (
    <LegalShell title="Refund & Cancellation Policy" product="sva-detox">
      <p className="text-sm" style={{ color: '#64748b' }}>Last updated: 10 June 2026</p>

      <p>
        This page summarises the refund & cancellation policy for <strong>Sva — Detox</strong> subscriptions purchased from BastionGuard Medical Technologies Pvt. Ltd. By starting a trial or paying for a subscription, you agree to the terms below in addition to our <a href="/products/sva-detox/terms">Terms of Service</a>.
      </p>

      <h2>1. 7-day Free Trial</h2>
      <p>Every new subscription begins with a <strong>7-day free trial</strong>. We collect your card details upfront via Razorpay to set up a mandate, but <strong>₹0 is charged during the trial</strong>. You may cancel anytime in those 7 days from <em>Sva → Profile → Subscription → Cancel</em>. If you cancel before day 8, <strong>no amount is debited from your account</strong>.</p>

      <h2>2. After the Trial — No Refunds</h2>
      <p>Once the trial ends and the first ₹199 (GST inclusive) is charged on day 8, we operate a <strong>strict, no-refund policy</strong> for that billing cycle. This includes (but is not limited to):</p>
      <ul>
        <li>Forgetting to cancel before day 8.</li>
        <li>Not using the app for the paid month.</li>
        <li>Changing your mind after the charge.</li>
        <li>Uninstalling the app while the subscription is active.</li>
      </ul>

      <h2>3. Cancellation After Charge</h2>
      <p>You can cancel a paid subscription anytime to stop future renewals. Your Pro access remains active until the end of the current billing cycle, then the account drops to free tier (paywalled). No pro-rata refund is issued for the unused portion of the current cycle.</p>

      <h2>4. Exceptional Refunds</h2>
      <p>We may, at our sole discretion, issue a refund in <strong>narrow exceptional cases</strong> such as:</p>
      <ul>
        <li><strong>Duplicate charges</strong> caused by a Razorpay or Sva system bug — verifiable on the Razorpay transaction log.</li>
        <li><strong>Unauthorised charge</strong> reported within 7 days of the charge date and confirmed via Razorpay dispute mechanism.</li>
        <li><strong>Service outage</strong> longer than 72 continuous hours preventing use of the app, confirmed by our incident records.</li>
      </ul>
      <p>These exceptional refunds are processed back to the same Razorpay payment method within 7–10 business days after approval. We do not issue cash, UPI direct, or third-party refunds.</p>

      <h2>5. How to Request a Refund</h2>
      <p>Email <a href="mailto:info@bastionguardhealthcare.in?subject=Refund%20Request%20%E2%80%94%20Sva%20Detox">info@bastionguardhealthcare.in</a> within <strong>7 days of the charge</strong>, including:</p>
      <ul>
        <li>Your Sva account email.</li>
        <li>The Razorpay payment ID (visible on the GST invoice email you received from us).</li>
        <li>A short reason for the request.</li>
      </ul>
      <p>We respond within 3 business days. Approved refunds are processed via Razorpay; the funds reach your bank/card within 5–7 working days from the approval date depending on your bank.</p>

      <h2>6. Chargebacks</h2>
      <p>We strongly recommend contacting <a href="mailto:info@bastionguardhealthcare.in">info@bastionguardhealthcare.in</a> <strong>before</strong> raising a chargeback with your bank. Unauthorised chargebacks may result in account suspension and recovery of associated fees.</p>

      <h2>7. Plan Changes & Pricing</h2>
      <p>Sva Pro is <strong>₹199/month (GST inclusive)</strong> at the time of writing. We reserve the right to change pricing for future billing cycles with at least 30 days{"'"} notice via email. Existing subscribers can cancel before the new rate kicks in if they don{"'"}t accept the change.</p>

      <h2>8. Contact</h2>
      <p>Refund questions, escalations, or grievance redressal:</p>
      <p>
        <strong>BastionGuard Medical Technologies Pvt. Ltd.</strong><br />
        372/E 1, Karunya Building, Podiyadi, Pathanamthitta – 689110, Kerala, India<br />
        GSTIN: <strong>32AAOCB1809M1ZK</strong><br />
        Email: <a href="mailto:info@bastionguardhealthcare.in">info@bastionguardhealthcare.in</a>
      </p>
      <p className="text-sm" style={{ color: '#64748b' }}>This refund policy forms part of the Sva — Detox Terms of Service. Where this page conflicts with the full Terms, the more specific language in this page applies.</p>
    </LegalShell>
  );
}
